import {
  CREATE_GATING_CONFIGURATION_REQUEST,
  UPDATE_GATING_CONFIGURATION_REQUEST, DELETE_GATING_CONFIGURATION_REQUEST, INVALIDATE_GATING_CONFIGURATIONS,
  DELETE_ASSET_MAPPINGS_GATING_REQUEST, DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED, DELETING_ASSET_MAPPINGS_GATING_FAILED,
  CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST, CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED, CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED,
  FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST, FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED, FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED
} from "constants/actionTypes";

import _ from 'lodash';
import shortid from 'shortid';

const initialGatingState = {
  loading: false,
  items: [],
  errors: null
};

const initialState = {};

function gatingConfigurationsReducer(state = initialState, action) {
  switch (action.type) {

    case CREATE_GATING_CONFIGURATION_REQUEST: {
      const { id, request } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      var items = [
        {
          ...request,
          updated: true
        },
        ...gatingState.items
      ];

      return {
        ...state,
        [id]: {
          ...gatingState,
          items: items
        }
      }
    }

    case UPDATE_GATING_CONFIGURATION_REQUEST: {
      const { mappingId, id, request } = action.payload;

      const gatingState = state[mappingId] || initialGatingState;

      if (!mappingId) {
        return state;
      }

      let items = gatingState.items.map(item => {
        if (item.uid === id) {
          return {
            ...item,
            updated: true,
            ...request
          }
        }

        return item;
      })

      return {
        ...state,
        [mappingId]: {
          ...gatingState,
          items: items
        }
      }
    }

    case DELETE_GATING_CONFIGURATION_REQUEST: {
      const { mappingId, id } = action.payload;

      const gatingState = state[mappingId] || initialGatingState;
      const deletedGatingItems = state.deletedGating || [];
      if (!mappingId) {
        return state;
      }

      let items = gatingState.items.filter(gating => {
        return id != gating.uid
      });

      const deletedItem = gatingState.items.find(gating => {
        return id === gating.uid
      });

      if (_.has(deletedItem, 'id')) {
        return {
          ...state,
          [mappingId]: {
            ...gatingState,
            items: items
          },
          deletedGating: [
            ...deletedGatingItems,
            _.get(deletedItem, 'id')
          ]
        }
      }

      return {
        ...state,
        [mappingId]: {
          ...gatingState,
          items: items
        }
      }
    }

    case DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED: {
      var { response } = action.payload;

      return {
        ...state,
        deletedGating: []
      }
    }

    case DELETING_ASSET_MAPPINGS_GATING_FAILED: {
      var { error } = action.payload;

      return {
        ...state,
        error: error
      }
    }

    case INVALIDATE_GATING_CONFIGURATIONS: {
      return initialState;
    }

    case CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST: {
      const { id  } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      let items = [...gatingState.items];
      items = items.map(item => {
        if(item.id) {
          return item;
        }

        return null;
      }).filter(item => item != null);

      return {
        ...state,
        [id]: {
          ...gatingState,
          items: items,
          creating: true
        }
      }
    }


    case CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED: {
      const { id, response } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      let items = [...gatingState.items];

      if(response.length > 0) {
        items = [...gatingState.items, ...response];
        items = _.uniqBy(items, 'id');
      }

      return {
        ...state,
        [id]: {
          ...gatingState,
          creating: false,
          items: items
        }
      }
    }


    case CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED: {
      const { id, error } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...gatingState,
          creating: false,
          error: error
        }
      }
    }

    case FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST: {
      const { id } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...gatingState,
          loading: true
        }
      }
    }


    case FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED: {
      const { id, response } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      var items = [...response];

      items = _.uniqBy(items, 'id');

      items = items.map(item => {
        return {
          ...item,
          uid: shortid()
        }
      });

      return {
        ...state,
        [id]: {
          ...gatingState,
          loading: false,
          items: items,
          errors: null
        }
      }
    }

    case FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED: {
      let { id, error } = action.payload;

      const gatingState = state[id] || initialGatingState;

      if (!id) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...gatingState,
          loading: false,
          errors: null,
          errors: error
        }
      }
    }

    default:
      return state;
  }
}

export { gatingConfigurationsReducer }